import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppInsightsService } from '@mri-platform/angular-app-insights';

@Component({
  selector: 'mri-dsg-root',
  template: ` <router-outlet></router-outlet> `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        min-height: 0;
        overflow: hidden;
      }
    `
  ],
  imports: [RouterOutlet],
  standalone: true
})
export class AppComponent {
  constructor(appInsights: AppInsightsService) {
    appInsights.whenEnabled(ai => ai.trackEvent({ name: 'app-started' }));
  }
}
